import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpEvent} from '@angular/common/http';
import {MediaDTO} from '@domain/media/media.dto';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  private readonly http = inject(HttpClient);

  public upload(url: string, file: File): Observable<HttpEvent<MediaDTO>> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<MediaDTO>(
      url,
      formData,
      {
        reportProgress: true,
        observe: 'events'
      }
    );
  }

  public download(url: string): Observable<any> {
    return this.http.get(url, {
      responseType: 'blob'
    });
  }

  public delete(deleteUrl: string): Observable<any> {
    return this.http.delete(deleteUrl);
  }

}
